import { Vue, Component, Prop } from 'vue-property-decorator';
import VueMultiSelect from 'vue-multiselect';
import { librarySettingsAPI } from '@/providers/apis/library/library';

@Component({
    name: 'content-source-form',
    components: {
        'vue-multi-select': VueMultiSelect,
    },
})

export default class ContentSourceForm extends Vue {

    // -------------------------------------------------------------------
    // Properties

    private contentSourceList: any = [
        {
            key: 'open-all',
            name: 'Gooru Catalog',
            keyObject: 'openAll',
            seq_id: 1,
        },
        {
            key: 'my-content',
            name: 'My Content',
            keyObject: 'myContent',
            seq_id: 2,
        },
        {
            key: 'course-map',
            name: 'Course Map',
            keyObject: 'courseMap',
            seq_id: 4,
        },
        {
            key: 'open-library',
            name: 'Open Library',
            keyObject: 'openLibrary',
            seq_id: 4,
        },
        {
            key: 'tenant-library',
            name: 'Tenant Library',
            keyObject: 'tenantLibrary',
            seq_id: 5,
        },
    ];

    @Prop()
    private value: any;

    private content: any = [];

    @Prop({ default: false })
    private isReadOnly!: boolean;

    @Prop({ default: 'value' })
    private valueFields!: string;

    @Prop({ default: 'text' })
    private textFields!: string;

    private dataStringValue: any = '';

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private selectedRecentItem: any = {};

    private dataByApi: any = {
        openAll: { list: [], selected: [] },
        myContent: { list: [], selected: [] },
        courseMap: { list: [], selected: [] },
        openLibrary: { list: [], selected: [] },
        tenantLibrary: { list: [], selected: [] },
    };

    // -------------------------------------------------------------------
    // Hooks

    private created() {
        this.content = this.value;
        // console.log('this.content', this.content);
        if (this.isReadOnly) {
            this.createStringForSettings();
        } else {
            this.checkPreSelectedValues();
            this.getLibraryList();
        }
    }

    private createStringForSettings() {
        if (this.content && this.content.length > 0) {
            let stringData = '';
            for (const iterator of this.content) {
                stringData += `${iterator.name}; `;
            }
            this.dataStringValue = stringData;
        }

    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private checkPreSelectedValues() {
        for (const iterator of this.contentSourceList) {
            const selectedIndex = this.content.findIndex((item: any) => {
                return item.name === iterator.name && item.key === iterator.key;
            });
            if (selectedIndex !== -1) {
                iterator.checked = true;
                iterator.preSelect = true;
                this.dataByApi[iterator.keyObject].selected = this.content[selectedIndex].libraries
                ? this.content[selectedIndex].libraries.default : [];
            }
        }
    }

    private onSelectItem(item: any) {
        // item.checked = true;
        this.selectedRecentItem = item;
    }

    private getLibraryList() {
        librarySettingsAPI.fetchLibraryItemListTenentAndOpen().then((data: any) => {
            const openLib = data.openLibrary;
            const tenentLib = data.tenantLibrary;
            const librayIndex = this.content.findIndex((item: any) => {
                return item.key === 'open-library';
            });
            let OpLibrary: any = {};
            if (librayIndex !== -1) {
                OpLibrary = this.content[librayIndex].libraries;
            } else {
                OpLibrary.default = [];
            }
            for (const iterator of openLib) {
                if (OpLibrary.default.includes(iterator.id)) {
                    iterator.preSelect = true;
                    iterator.checked = true;
                }
            }
            this.dataByApi.openLibrary.list = openLib;
            const tenantIndex = this.content.findIndex((item: any) => {
                return item.key === 'tenant-library';
            });
            let tenLibrary: any = {};
            if (tenantIndex !== -1) {
                tenLibrary = this.content[tenantIndex].libraries;
            } else {
                tenLibrary.default = [];
            }
            for (const iterator of tenentLib) {
                if (tenLibrary.default.includes(iterator.id)) {
                    iterator.preSelect = true;
                    iterator.checked = true;
                }
            }
            this.dataByApi.tenantLibrary.list = tenentLib;
        });
    }

    private onChangeCategory(item: any) {
        // console.log('item', item);
        const perExistIndex = this.value.findIndex((preExist: any) => {
            return preExist.key === item.key;
        });
        if (item.checked) {
            if (perExistIndex === -1) {
                const newObj: any = {
                    key: item.key,
                    name: item.name,
                    seq_id: item.seq_id,
                };
                if (item.key === 'open-library') {
                    newObj.libraries = {
                        default: [],
                    };
                    this.dataByApi[this.selectedRecentItem.keyObject].list.map((itemSelect: any) => {
                        if (itemSelect.checked) {
                            newObj.libraries.default.push(itemSelect.id);
                        }
                    });
                }
                this.value.push(newObj);
            }
        } else {
            if (perExistIndex !== -1) {
                this.value.splice(perExistIndex, 1);
            }
        }

    }

    private onChangeListItem() {
        const librayIndex = this.value.findIndex((item: any) => {
            return item.key === this.selectedRecentItem.key;
        });
        if (librayIndex !== -1) {
            this.value[librayIndex].libraries.default = [];
            this.dataByApi[this.selectedRecentItem.keyObject].list.map((item: any) => {
                if (item.checked) {
                    this.value[librayIndex].libraries.default.push(item.id);
                }
            });
        }
    }

    private onChangeItem(event: any, key: any, index: any) {
        // console.log('event', event);
        // console.log('key', key);
        // console.log('index', index);
    }

}
